import { ReportProvider } from '@motorway/motorway-handshake-components';

import { useDriver } from '../../contexts/Driver';

export const ReportWrapperComponent: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { driver } = useDriver();
  const { enquiryId = null, token = null } = driver ?? {};

  return (
    <ReportProvider {...{ enquiryId, token }}>
      {children}
    </ReportProvider>
  );
};
